function Visionaries() {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10">
          Our Visionaries
        </h1>

        {/* Chief Mentor */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            Chief Mentor’s Message
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            Our vision “To Build New Generation” is a commitment to create not
            just knowledge, but wisdom. Each letter of CAPITOL represents values
            like Character, Purity, Truth, Intuition, Outlook, and Love.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            Education at Capitol focuses on transforming knowledge into wisdom,
            nurturing students into responsible, thoughtful, and capable
            individuals.
          </p>

          <p className="font-semibold text-blue-900 mt-4">
            V K Parthasarathy — Chief Mentor
          </p>
        </div>

        {/* Chairman */}
        <div>
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">
            Chairman’s Message
          </h2>

          <p className="text-gray-700 leading-relaxed mb-4">
            Education shapes young minds and prepares them for the future. Our
            goal is to encourage creativity, thinking, and knowledge to make
            students capable and responsible citizens.
          </p>

          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Research and knowledge management</li>
            <li>Creativity and innovation</li>
            <li>Use of modern technology</li>
            <li>Entrepreneurial leadership</li>
            <li>Moral leadership</li>
          </ul>
        </div>

      </div>
    </section>
  );
}

export default Visionaries;